export default function makeUrl(link = "") {
  return link.includes("https://") == true
    ? link
    : link.includes("http://")
    ? link
    : `https://${link}`;
}
